import { INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND } from '@lexical/list';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulletedRounded';
import { LexicalEditor } from 'lexical';
import React from 'react';
import { StyledButton } from '../../styles';

interface Props {
  blockType: string;
  isEditable: boolean;
  editor: LexicalEditor;
}

export default function FormatListUnorderedButton(props: Props) {
  const { blockType, isEditable, editor } = props;
  const formatBulletList = React.useCallback(() => {
    if (blockType !== 'bullet') {
      editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
    } else {
      editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
    }
  }, [blockType, editor]);

  return (
    <StyledButton
      disabled={!isEditable}
      onClick={() => {
        formatBulletList();
      }}
      className={`toolbar-item spaced ${blockType === 'bullet' ? 'active' : ''}`}
      title="Bullet List"
      type="button"
      aria-label="Format text as bullet list"
    >
      <FormatListBulletedIcon />
    </StyledButton>
  );
}
